import { useTracking } from '../../hooks/useTracking';

// Подключает трекинг (session_start + page_view + привязку пользователя).
// Должен рендериться внутри <Router> и AppContextProvider.
export default function TrackingProvider() {
  useTracking();
  return null;
}
